import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { Pencil, Plus, Trash } from "@phosphor-icons/react";
import { t } from "i18next";

const config = {
  modelName: "room",
  modelPluralName: "rooms",
  endpoint: "rooms",
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "shed",
        label: "shed",
        key: "shed",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "name",
        label: "room",
        key: "name",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "available",
        label: "available",
        key: "available",
        type: "boolean",
        show: true,
        allowOrder: true,
      },
      {
        name: "dog",
        label: "dog",
        key: "dog",
        type: "boolean",
        show: true,
        allowOrder: true,
      },
      {
        name: "cat",
        label: "cat",
        key: "cat",
        type: "boolean",
        show: true,
        allowOrder: true,
      },
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: {
        type: "string",
      },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    properties: {
      // Shed
      shed: {
        type: "string",
        title: t("shed"),        
      },
      // Name
      name: {
        type: "string",
        title: t("room"),
      },
      // Available
      available: {
        type: "boolean",
        title: t("available"),
        default: true,
      },
      // Dog
      dog: {
        type: "boolean",
        title: t("dog"),
        default: true,
      },
      // Cat
      cat: {
        type: "boolean",
        title: t("cat"),
        default: false,
      },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
  }
};
export default config;
